import React, { FC } from 'react'

import { IconFamilyProps } from './IconFamily.types'
import * as Styled from './styles/IconFamily.style'

import { nonThemeableRules } from '../../ruleSet'

const IconFamily: FC<IconFamilyProps> = ({
  size = nonThemeableRules.defaultSize as number as IconFamilyProps['size'],
  isResponsive = false,
}: IconFamilyProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M7 35c1.22-7.442 5.585-11.985 11-11.985a9.168 9.168 0 0 1 4.77 1.322l.075.046'
          stroke='#E60000'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
        <path
          d='M30.25 23.56A6.952 6.952 0 0 1 33 23c3.938 0 7.11 3.155 8 8.317'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
        <path
          d='M32.913 39c-.858-4.97-3.703-7.53-6.87-7.53-3.168 0-6.095 2.56-6.956 7.53'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path d='M18 9h7v7a7 7 0 1 1-7-7v0Z' stroke='#E60000' strokeLinecap='round' strokeMiterlimit='10' strokeWidth='2' />
        <path
          d='M33 13h5v5a5 5 0 0 1-5 5v0a5 5 0 0 1-5-5v0a5 5 0 0 1 5-5v0Zm-7 9.983h4.25v4.25a4.25 4.25 0 0 1-4.25 4.25v0a4.25 4.25 0 0 1-4.25-4.25v0a4.25 4.25 0 0 1 4.25-4.25Z'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconFamily
